const PlusCircled = (props) => (
  <svg width={32} height={32} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={16} cy={16} r={16} fill="#335683" />
    <g clipPath="url(#plus-circled_svg__a)">
      <path d="M23 17h-6v6h-2v-6H9v-2h6V9h2v6h6v2Z" fill="#fff" />
    </g>
    <defs>
      <clipPath id="plus-circled_svg__a">
        <path fill="#fff" transform="translate(4 4)" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default PlusCircled;
